import './App.css'
import Layout from '@cox/core-ui8/dist/Layout'
import AppRoutes from './AppRoutes'

const App = () => {
  return (
    <Layout appName='authres'>
      <AppRoutes />
    </Layout>
  )
}

export default App
